module.exports = __webpack_public_path__ + "static/media/logo-핏펫@3x.0921396e.png";